import 'ui-core/widgets/search-result/js/search-result';

(function () {
    UX.searchResult.additionalInit = function () {
        $('.search-result-right').each(function () {
            if (
                $('.search-result-right').attr('data-enable-mathjax') === 'true' &&
                ($('.math-formula').length ||
                    $('.disp-formula').length ||
                    $('.inline-formula').length ||
                    $('math').length)
            ) {
                const script = document.createElement('script');
                script.type = 'text/javascript';
                script.src =
                    'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.5/MathJax.js?config=TeX-AMS-MML_HTMLorMML'; // use the location of your MathJax
                const config =
                    'MathJax.Hub.Config({' +
                    'CommonHTML: { linebreaks: { automatic: true } },' +
                    '"HTML-CSS": { linebreaks: {automatic: true}},' +
                    'SVG: { linebreaks: { automatic: true} },' +
                    '});';

                if (window.opera) {
                    script.innerHTML = config;
                } else {
                    script.text = config;
                }
                document.getElementsByTagName('head')[0].appendChild(script);
            }
        });
    };
})();
